module.exports = "<footer>\n  <div class=\"version\">Version: {{ version }}</div>\n</footer>\n"